<template>
  <div class="vgt-table-pagination">
    <div class="vgt-table-pagination-selector">
      <p>{{ t('authot_elements.pagination.display') }}</p>
      <div class="ui selection dropdown per-page-dropdown" :id="dropdownId">
        <input type="hidden">
        <i class="dropdown icon"></i>
        <div class="default text">10</div>
        <div class="scrollhint menu">
          <div class="item" data-value="10">10</div>
          <div class="item" data-value="20">20</div>
          <div class="item" data-value="30">30</div>
        </div>
      </div>
      <p>{{ t('authot_elements.pagination.elements') }}</p>
    </div>
    <div class="vgt-table-pagination-pages">
      <div class="vgt-table-pagination-pages-start-arrows">
        <button class="vgt-table-pagination-pages-rounded-btn" @click="customPageChange(1)"><i class="angle double left icon"></i></button>
        <button class="vgt-table-pagination-pages-rounded-btn" @click="getPreviousPage()"><i class="angle left icon"></i></button>
      </div>
      <div v-for="(page, i) in pages" :key="i">
        <button class="vgt-table-pagination-pages-rounded-btn" :class="{ 'active': i + 1 == current } " @click="customPageChange(i + 1)">{{ i + 1 }}</button>
      </div>
      <div class="vgt-table-pagination-pages-end-arrows">
        <button class="vgt-table-pagination-pages-rounded-btn" @click="getNextPage()"><i class="angle right icon"></i></button>
        <button class="vgt-table-pagination-pages-rounded-btn" @click="customPageChange(pages)"><i class="angle double right icon"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['total', 'pageChanged', 'perPageChanged', 'dropdownId'],
  data() {
    return {
      perPage: 1,
      current: 1,
      pages: 1
    }
  },
  computed: {
    t() {
      return this.$store.getters['locales/t']
    }
  },
  methods: {
    getPreviousPage() {
      if(this.current != 1) this.customPageChange(this.current - 1);
    },
    getNextPage() {
      if(this.current + 1 != this.pages + 1) this.customPageChange(this.current + 1);
    },
    customPageChange(customCurrentPage) {
      this.current = customCurrentPage;
      this.pageChanged({currentPage: customCurrentPage});
    },
    customPerPageChange(customPerPage) {
      this.perPage = customPerPage;
      this.getTotalPages();
      this.perPageChanged({currentPerPage: customPerPage});
    },
    getTotalPages() {
      if(this.total > this.perPage) {
        this.pages = Math.ceil(this.total/this.perPage);
      } else {
        this.pages = 1;
      }
    }
  },
  watch: {
    total: {
      deep: true,
      handler() {
        this.getTotalPages();
      }
    }
  },
  mounted() {
    $('#' + this.dropdownId).dropdown({
      onChange: (val) => {
        this.customPerPageChange(val);
      }
    })
    $('#' + this.dropdownId).dropdown('set selected', 10);
  }
}
</script>